import { Toggle } from '../../../utilities/toggle.js'

const buttons = document.querySelectorAll('.js-nav-group-button')

buttons.forEach(button => {
  new Toggle(button).init()
})
